<template>
  <div>
    <h1>{{ $t('app.name') }}</h1>
    <Information/>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn outlined color="success" :to="{ name: 'Config' }">
            <v-icon>settings</v-icon>
            {{ $t('link.config') }}
          </v-btn>
        </v-col>
      </v-row>
  </div>
</template>

<script>
import Information from "@/components/Information"

export default {
  components: {
    Information
  },
  mounted() {
    this.$storage.doneAbout()
  }
}
</script>